<script lang="ts">import { textActive as defaultIconColor } from "../icons/colors";
import { cfgToThemeCdnPath } from "@infinitro/config";
export let icon;
export let size = 20;
export let color = null;
export let hover = false;
export let active = false;
export let replaceFill = true;
export let activeColor = "var(--color-primary-500)";
const iconMap = {
	// Sports icons
	AmericanFootballIcon: cfgToThemeCdnPath("/sports-icons/american-football.svg"),
	BaseballIcon: cfgToThemeCdnPath("/sports-icons/baseball.svg"),
	BasketballIcon: cfgToThemeCdnPath("/sports-icons/basketball.svg"),
	BoxingIcon: cfgToThemeCdnPath("/sports-icons/boxing.svg"),
	CounterStrikeIcon: cfgToThemeCdnPath("/sports-icons/counter-strike.svg"),
	CricketIcon: cfgToThemeCdnPath("/sports-icons/cricket.svg"),
	CyclingIcon: cfgToThemeCdnPath("/sports-icons/cycling.svg"),
	DartsIcon: cfgToThemeCdnPath("/sports-icons/darts.svg"),
	DotaIcon: cfgToThemeCdnPath("/sports-icons/dota.svg"),
	ECricketIcon: cfgToThemeCdnPath("/sports-icons/e-cricket.svg"),
	F1Icon: cfgToThemeCdnPath("/sports-icons/f1.svg"),
	FavoritesIcon: cfgToThemeCdnPath("/sports-icons/favorite.svg"),
	FifaIcon: cfgToThemeCdnPath("/sports-icons/fifa.svg"),
	FootballIcon: cfgToThemeCdnPath("/sports-icons/football.svg"),
	FutsalIcon: cfgToThemeCdnPath("/sports-icons/futsal.svg"),
	GolfIcon: cfgToThemeCdnPath("/sports-icons/golf.svg"),
	IceHockeyIcon: cfgToThemeCdnPath("/sports-icons/ice-hockey.svg"),
	LoLIcon: cfgToThemeCdnPath("/sports-icons/league-of-legends.svg"),
	LiveIcon: cfgToThemeCdnPath("/sports-icons/live.svg"),
	MmaIcon: cfgToThemeCdnPath("/sports-icons/mma.svg"),
	MyBetsIcon: cfgToThemeCdnPath("/sports-icons/my-bets.svg"),
	NBAIcon: cfgToThemeCdnPath("/sports-icons/nba-2k.svg"),
	NFLIcon: cfgToThemeCdnPath("/sports-icons/nfl.svg"),
	RacingIcon: cfgToThemeCdnPath("/sports-icons/racing.svg"),
	RugbyIcon: cfgToThemeCdnPath("/sports-icons/rugby.svg"),
	ScheduleIcon: cfgToThemeCdnPath("/sports-icons/schedule.svg"),
	SnookerIcon: cfgToThemeCdnPath("/sports-icons/snooker.svg"),
	SpecialsIcon: cfgToThemeCdnPath("/sports-icons/specials.svg"),
	TennisIcon: cfgToThemeCdnPath("/sports-icons/tennis.svg"),
	VolleyballIcon: cfgToThemeCdnPath("/sports-icons/volleyball.svg"),
	WaterpoloIcon: cfgToThemeCdnPath("/sports-icons/waterpolo.svg"),
	AussieRulesIcon: cfgToThemeCdnPath("/sports-icons/aussie-rules.svg"),
	HandballIcon: cfgToThemeCdnPath("/sports-icons/handball.svg"),
	NBA2KIcon: cfgToThemeCdnPath("/sports-icons/nba-2k.svg"),
	SquashIcon: cfgToThemeCdnPath("/sports-icons/squash.svg"),
	TableTennisIcon: cfgToThemeCdnPath("/sports-icons/table-tennis.svg"),
	eCricketIcon: cfgToThemeCdnPath("/sports-icons/e-cricket.svg"),
	StarCraftIcon: cfgToThemeCdnPath("/sports-icons/starcraft.svg"),
	EfightingIcon: cfgToThemeCdnPath("/sports-icons/efighting.svg"),
	WaterPoloIcon: cfgToThemeCdnPath("/sports-icons/waterpolo.svg"),
	EhorseRacingIcon: cfgToThemeCdnPath("/sports-icons/ehorse-racing.svg"),
	// Sidebar icons
	PointsIcon: cfgToThemeCdnPath("/sidebar/points02.svg"),
	CardsIcon: cfgToThemeCdnPath("/sidebar/casino.svg"),
	LobbyIcon: cfgToThemeCdnPath("/sidebar/casino.svg"),
	OriginalsIcon: cfgToThemeCdnPath("/sidebar/originals.svg"),
	PopularIcon: cfgToThemeCdnPath("/sidebar/popular.svg"),
	NewGamesIcon: cfgToThemeCdnPath("/sidebar/new.svg"),
	PromotionIcon: cfgToThemeCdnPath("/sidebar/promotions.svg"),
	GiftIcon: cfgToThemeCdnPath("/sidebar/gift.svg"),
	GameShowsIcon: cfgToThemeCdnPath("/sidebar/gameshows.svg"),
	ProviderIcon: cfgToThemeCdnPath("/sidebar/providers.svg"),
	FeatureBuyInIcon: cfgToThemeCdnPath("/sidebar/featurebuyin.svg"),
	SlotsIcon: cfgToThemeCdnPath("/sidebar/slots.svg"),
	ReferralIcon: cfgToThemeCdnPath("/sidebar/refer.svg"),
	ReferralIconAnimated: cfgToThemeCdnPath("/sidebar/refer.webp"),
	AffiliateIcon: cfgToThemeCdnPath("/sidebar/casino.svg"),
	VipIcon: cfgToThemeCdnPath("/sidebar/vip.svg"),
	BlogIcon: cfgToThemeCdnPath("/sidebar/blog.svg"),
	LeaderboardIcon: cfgToThemeCdnPath("/sidebar/races.svg"),
	LiveCasinoIcon: cfgToThemeCdnPath("/sidebar/live.svg"),
	AllGamesIcon: cfgToThemeCdnPath("/sidebar/casino.svg"),
	RecentlyPlayedIcon: cfgToThemeCdnPath("/sidebar/recently.svg"),
	FavoritesUserIcon: cfgToThemeCdnPath("/sidebar/favorite.svg"),
	SportsIcon: cfgToThemeCdnPath("/sidebar/sports.svg"),
	TournamentsIcon: cfgToThemeCdnPath(`/sidebar/tournaments.svg`),
	BetsIcon: cfgToThemeCdnPath(`/sidebar/bets.svg`),
	RafflesIcon: cfgToThemeCdnPath(`/sidebar/raffles.svg`),
	JackpotIcon: cfgToThemeCdnPath(`/sidebar/jackpot.svg`),
	ChatIcon: cfgToThemeCdnPath(`/sidebar/chat.svg`),
	MobileMenuIcon: cfgToThemeCdnPath("/mobile-menu/menu.svg"),
	MobileCasinoIcon: cfgToThemeCdnPath("/mobile-menu/casino.svg"),
	MobilePromotionIcon: cfgToThemeCdnPath("/mobile-menu/promotions.svg"),
	MobileSportsIcon: cfgToThemeCdnPath("/mobile-menu/sports.svg"),
	MobileBetsIcon: cfgToThemeCdnPath(`/mobile-menu/bets.svg`),
	MobileChatIcon: cfgToThemeCdnPath(`/mobile-menu/chat.svg`),
	MobileFullScreenIcon: cfgToThemeCdnPath(`/mobile-menu/full-screen.svg`),
	MobileChallengesIcon: cfgToThemeCdnPath(`/mobile-menu/challenges.svg`),
	MobileDepositIcon: cfgToThemeCdnPath(`/mobile-menu/deposit.svg`),
	MobileWithdrawIcon: cfgToThemeCdnPath(`/mobile-menu/withdraw.svg`),
	MobileSearchIcon: cfgToThemeCdnPath(`/mobile-menu/search.svg`),
	SearchIcon: cfgToThemeCdnPath(`/icons/search.svg`),
	SupportChatHelpIcon: cfgToThemeCdnPath("/support-chat/help.svg"),
	SupportChatHomeIcon: cfgToThemeCdnPath("/support-chat/home.svg"),
	SupportChatMessagesIcon: cfgToThemeCdnPath("/support-chat/messages.svg"),
	SupportChatSendIcon: cfgToThemeCdnPath("/support-chat/send.svg"),
	SupportIcon: cfgToThemeCdnPath(`/sidebar/support.svg`),
	MobileJackpotIcon: cfgToThemeCdnPath(`/mobile-menu/jackpot.svg`),
	// Other
	UpChevron: cfgToThemeCdnPath("/icons/up.png"),
	DownChevron: cfgToThemeCdnPath("/icons/down.png"),
	WalletIcon: cfgToThemeCdnPath("/icons/wallet.svg"),
	RewardsIcon: cfgToThemeCdnPath("/icons/rewards.png"),
	ArrowIcon: cfgToThemeCdnPath("/icons/arrow.svg"),
	ArrowLeftIcon: cfgToThemeCdnPath("/icons/arrow-left.svg"),
	ArrowRightIcon: cfgToThemeCdnPath("/icons/arrow-right.svg"),
	CopyIcon: cfgToThemeCdnPath("/icons/copy.svg"),
	LockIcon: cfgToThemeCdnPath("/icons/lock.svg")
};
let svgContent = "";
let error = false;
/** When inline SVG fetch fails (network, 404, or missing CORS), load via img — works cross-origin without CORS. */
let svgImgFallback = false;
$: computedColor = color ?? (hover || active ? activeColor : defaultIconColor);
let isSvg = true;
let filePath;
let loadRequestId = 0;
const loadIconAsset = async () => {
	const currentRequestId = ++loadRequestId;
	filePath = iconMap[icon] ?? cfgToThemeCdnPath("/sports-icons/placeholder.svg");
	isSvg = filePath.endsWith(".svg");
	svgContent = "";
	svgImgFallback = false;
	if (isSvg) {
		try {
			const res = await fetch(filePath);
			if (!res.ok) throw new Error("SVG not found");
			let rawSvg = await res.text();
			if (replaceFill) {
				rawSvg = rawSvg.replace(/fill="[^"]*"/g, "fill=\"currentColor\"");
			}
			if (currentRequestId !== loadRequestId) return;
			svgContent = rawSvg;
			error = false;
		} catch (err) {
			console.warn(`⚠️ Icon '${icon}' could not load inline from ${filePath}. Using <img> fallback.`, err);
			if (currentRequestId !== loadRequestId) return;
			svgImgFallback = true;
			error = true;
		}
	}
};
$: {
	icon;
	replaceFill;
	loadIconAsset();
}
</script>

<div
	class="remote-icon {active || hover ? 'remote-icon-active' : ''} {replaceFill
		? 'replace-fill'
		: ''}"
	style="width: {size}px; height: {size}px; color: {computedColor};"
>
	{#if isSvg && !svgImgFallback}
		{@html svgContent}
	{:else if isSvg && svgImgFallback}
		<img class="remote-icon-img-fallback" src={filePath} alt="" width={size} height={size} />
	{:else}
		<img src={filePath} alt={icon} width={size} height={size} />
	{/if}
</div>

<style>
	.remote-icon {
		display: flex;
		align-items: center;
		justify-content: center;
}

	:global(.remote-icon.replace-fill svg) {
		fill: currentColor;
	}

	:global(.remote-icon svg) {
		width: 100%;
		height: 100%;
		display: block;
		transition:
			fill 0.2s ease,
			opacity 0.2s ease;
	}

	.remote-icon-img-fallback {
		width: 100%;
		height: 100%;
		-o-object-fit: contain;
		   object-fit: contain;
		display: block;
	}
</style>
